const TABSTER_DUMMY_SELECTOR = '[data-tabster-dummy][aria-hidden="true"]';

const exposeTabsterDummies = (root: ParentNode): void => {
  if (root instanceof Element && root.matches(TABSTER_DUMMY_SELECTOR)) {
    root.removeAttribute('aria-hidden');
  }
  root.querySelectorAll(TABSTER_DUMMY_SELECTOR).forEach((element) => element.removeAttribute('aria-hidden'));
};

export const enforceTabsterDummyAccessibility = (document: Document): (() => void) => {
  exposeTabsterDummies(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) exposeTabsterDummies(node);
      });

      if (mutation.type === 'attributes' && mutation.target instanceof Element) {
        exposeTabsterDummies(mutation.target);
      }
    });
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden'],
  });

  return () => observer.disconnect();
};
